<!--  -->
<template>
  <div>
    <div class="infoPaddingCss">
      <div>
        <div class="flexButton">
          <span class="fontWeight">订单信息</span>
          <div v-if="isHavePermission('twoSettlement:createTime')"
              style="color: #a7adad"
          >创建人: {{ deailCreateUser }}
            <span
                v-if="isHavePermission('twoSettlement:createTime')">| 创建日期: {{ deailCreateTime | timePartRule }}</span>
          </div>
        </div>
        <vxe-table auto-resize border="inner" :data="orderTableData" align="center">
          <vxe-table-column field="paymentsNum" title="结算编号" show-overflow>

          </vxe-table-column>
          <vxe-table-column field="ordersBuyerNum" title="订单编号" show-overflow>
            <template slot-scope="{ row }">
              <a @click="showBuyerDetail(row)">{{ row.ordersNum }}</a>
            </template>
          </vxe-table-column>
          <vxe-table-column field="buyerName" title="托运人名称" show-overflow></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业" show-overflow></vxe-table-column>
          <vxe-table-column field="sellerName" title="承运人名称" show-overflow></vxe-table-column>
        </vxe-table>
      </div>
      <div style="margin-top: 10px;">
        <div class="flexButton">
          <span class="fontWeight">物流信息</span>
        </div>
        <vxe-table
            auto-resize
            border="inner"
            :data="logisticsShowData"
            stripe
            highlight-hover-row
            align="center"
        >
          <vxe-table-column field="goodsName" title="货名" show-overflow></vxe-table-column>
          <vxe-table-column field="goodsUnit" title="单位"></vxe-table-column>
          <vxe-table-column field="realCount" title="实际数量"></vxe-table-column>
          <vxe-table-column field="carShipNum" title="车船号" show-overflow>
            <template slot-scope="{ row }">
              <span
                  v-if="row.trackUrl || row.logisticsType === 2"
                  @click="getMap(row)"
                  style="color: #2D8CF0;cursor:pointer"
              >{{ row.carShipNum }}</span>
              <span v-if="!row.trackUrl && row.logisticsType !== 2 ">{{ row.carShipNum }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="beginPlace" title="起运地" show-overflow></vxe-table-column>
          <vxe-table-column field="beginTime" title="起运时间" width="100">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.beginTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="endPlace" title="到达地" show-overflow></vxe-table-column>
          <vxe-table-column field="endTime" title="到达时间" width="100">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.endTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div style="margin-top: 10px;" class="infoPaddingCss">
        <div class="flexButton">
          <span class="fontWeight">结算信息</span>
        </div>
        <vxe-table
            auto-resize
            border="inner"
            align="center"
            :data="receivingTableData"
            :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="paymentType" title="结算类型">
            <template v-slot="{row}">
              <span>{{ row.paymentType | receiveTypeRule }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="addTime" title="结算时间">
            <template v-slot="{ row }">
              <span>{{ row.addTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="totalAmount" title="结算金额">
            <template v-slot="{row}">
              <span>{{ row.totalAmount }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="note" title="摘要" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.note }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="备注" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.remark }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="add-box">
        <vxe-table
            show-overflow
            :auto-resize="true"
            class="table-upload-style"
            max-height="200"
            :data="uploadData"
            :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="url" title="查看附件">
            <template v-slot="{row}">
              <upload-list :isEdit="false" :row="row" :initFileList="uploadList" :view="'arrange'"></upload-list>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div v-show="trackFlag" class="trackBoxModal">
      <div style="display: flex;justify-content: space-between;">
        <div
            style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;"
        >{{ isCar ? '车辆轨迹' : '船舶轨迹' }}
        </div>
        <div
            @click="trackFlag = false"
            style="margin-right: 5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;"
        >关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width:100%;height:91vh;overflow: hidden;"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
      <!--      <iframe-view v-if="!isCar" :obj="shipObj"></iframe-view>-->
    </div>

  </div>
</template>

<script>
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import DetailModal from "@/views/logistics/DetailModal";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import UploadList from "@/components/common/UploadList";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    UploadList,
  },
  mixins: [getAuthOrization, viewOrderDetail],
  data() {
    return {
      logisticsShowData: [],
      isCar: true,
      url: null,
      currentPage2: 1,
      pageSize2: 5,
      totalResult2: 300,
      trackFlag: false,
      deailReceiveNum: null,
      deailCreateUser: null,
      deailCreateTime: null,
      orderTableData: [],
      showPicIndex: 0,
      receivingTableData: [],
      logisticsTableData: [],
      logisticDetailVisible: false,
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      uploadList: [],
    };
  },
  filters: {
    receiveTypeRule(p) {
      if (p == 1) {
        return "托运人结算";
      } else if (p == 2) {
        return "承运人结算";
      }
    },
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    async getReceivingDetail(row) {
      var self = this;
      self.receivingTableData = [];
      self.logisticsShowData = [];
      self.orderTableData = [];
      self.editUuidList = [];
      self.uploadList = [];

      var objReceive = {};
      var objOrder = {};
      var objLogistic = {};
      var data = {
        id: row.id,
      };
      let response = await $api.twoSettlement.request(
          "detail",
          data
      );
      if (response.status == 1) {
        let res = response.data;
        self.deailReceiveNum = res.paymentsDetail.paymentsNum;
        self.deailCreateUser = res.paymentsDetail.createUser;
        self.deailCreateTime = res.paymentsDetail.updateTime;
        //结算信息
        // objReceive.addTime = res.addTime;
        objReceive.addTime = this.$utils.toDateString(
            res.paymentsDetail.addTime,
            "yyyy-MM-dd"
        );
        if (res.ordTwoOrders != null) {
          //订单信息
          objOrder.ordersNum = res.ordTwoOrders.ordersNum;
          objOrder.ordersId = res.paymentsDetail.ordersId;
          objOrder.paymentsNum = res.paymentsDetail.paymentsNum;
          objOrder.buyerName = res.ordTwoOrders.buyerName;
          objOrder.chainNum = res.ordTwoOrders.chainNum;
          objOrder.sellerName = res.ordTwoOrders.sellerName;
          objOrder.chainId = res.ordTwoOrders.chainId;
          objOrder.compName = res.ordTwoOrders.compName;
          objOrder.createUser = res.ordTwoOrders.createUser;
          objOrder.createTime = res.ordTwoOrders.createTime;
          objOrder.ordersBuyerId = res.ordTwoOrders.ordersBuyerId;
          objOrder.ordersSellerId = res.ordTwoOrders.ordersSellerId;
          objOrder.ordersSellerLv2Id = res.ordTwoOrders.ordersSellerLv2Id;
          self.orderTableData.push(objOrder);
          //物流信息
          objLogistic.goodsName = res.ordTwoOrders.goodsName;
          objLogistic.goodsUnit = res.ordTwoOrders.goodsUnit;
          objLogistic.realCount = res.ordTwoOrders.realCount;
          objLogistic.carShipNum = res.ordTwoOrders.carShipNum;
          objLogistic.logisticsType = res.ordTwoOrders.logisticsType;
          objLogistic.trackUrl = res.ordTwoOrders.trackUrl;
          objLogistic.beginPlace = res.ordTwoOrders.beginPlace;
          objLogistic.beginTime = res.ordTwoOrders.beginTime;
          objLogistic.endPlace = res.ordTwoOrders.endPlace;
          objLogistic.endTime = res.ordTwoOrders.endTime;
          self.logisticsShowData.push(objLogistic);
        }
        objReceive.id = res.paymentsDetail.id;
        objReceive.totalAmount = res.paymentsDetail.totalAmount;
        objReceive.note = res.paymentsDetail.note;
        objReceive.paymentType = res.paymentsDetail.paymentType;
        objReceive.remark = res.paymentsDetail.remark;
        self.receivingTableData.push(objReceive);

        //图片信息
        if (res.fileList != null) {
          res.fileList.map((i) => {
            self.editUuidList.push(i.uuid);
            self.uploadList.push(i);
          });
        }
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.isCar = true;
        this.seeCarMap(row);
      } else {
        this.isCar = false;
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      this.trackFlag = true;
      this.url = '/carShip/fwCarFrame';
      this.$nextTick(function () {
        setTimeout(function () {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
        }, 5000);
      });
    },
    seeShipMap(row) {
      let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
      if (mmsi == null || mmsi === '') {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi
      }
      this.trackFlag = true;
      let that = this;
      if (this.url === '/carShip/fwShipFrame') {
        let mapFrame = that.$refs.mapFrame;
        let iframeWin = mapFrame.contentWindow
        iframeWin.postMessage(JSON.stringify(obj), '*')
      } else {
        this.url = '/carShip/fwShipFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(JSON.stringify(obj), '*')
          }, 5000);
        });
      }
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
    showLogisticsDetail(row) {
      if (!this.isHavePermission('logistics2.0:showDetail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.logisticDetailVisible = true;
      this.$refs.modalDetail.queryLogisticsDetail(row.id);
    },
    clickFile(url) {
      window.open(url);
    },
    showChainDetail(row) {
      if (!this.isHavePermission('chain:detail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.$router.push(`/order/detail/${row.chainId}`);
      this.$emit("closeRec", false);
    },
    showBuyerDetail(row) {
      this.openOrderDetailTwo(row.ordersId)
    },
  },
};
</script>
<style>
.trackBoxModal {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: #fff;
}

/* .flexButton {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
} */

.pdf-box1 {
  display: inline-block;
  position: relative;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 60px;
  height: 60px;
  overflow: hidden;
}

.infoPaddingCss .vxe-pager .vxe-pager--sizes {
  width: 7em;
  text-align: center;
  cursor: pointer;
  display: none;
}
</style>
